import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import HomePage from './pages/index';
import TermsPage from './TermsPage';
import PreSaleTermsPage from './PreSaleTermsPage';

function App() {

  return (
    <NotificationProvider>
        <Router>
          <Routes>
          <Route key="home" path="/" element={<HomePage />} />
          <Route key="terms" path="/terms" element={<TermsPage />} />
          <Route key="preterms" path="/pre-sale-terms" element={<PreSaleTermsPage />} />
          </Routes>
        </Router>
    </NotificationProvider>
  );
}

export default App;